export default "__VITE_ASSET__DoZQHnAl__"